<template>
  <SidePanel
    :isVisible="true"
    @cancel="onCancel"
    :header="header"
  >
    <div class="design-mode">
        <template>
            <CustomBrandingTemplates 
                :showButtons="true" 
                :selectLabel="$t('customBranding.currentlySelectedDesign')"
                @change="initializeConfig"
                @save="save()"
                @saveAs="saveAs()"
                @deleteTemplateConfirmation="deleteTemplateConfirmation()"
                ref="refBrandingTemplate"
                :reRenderData="reRenderData"
            >
            </CustomBrandingTemplates>
        </template>
        <!-- custom logo component -->
        <div class="panel-section-header text-panel-section-header mt-2">
            {{ $t('customBranding.customLogo') }}
        </div>
        <div class="your-logo-section"> 
            <div @click="openCustomLogo" class="d-flex pointer logo-manager-parent">
                <div class="d-flex flex-column justify-content-center">
                    <span class="text-weight-semi-bold">
                        {{ $t('customBranding.manageYourLogos') }}
                    </span>
                    <!-- <div class="text-size-10 pt-0 toggle-description">
                        {{ $t('customLogo.description') }}
                    </div> -->
                    </div>
                    <div class="logo-image-update flex-column">
                    <img
                        class="ml-auto mr-2 flex-column border-radius custom-logo-image"
                        height="50"
                        :src="logoThumbnail"
                        alt=""
                    />
                    <icon class="h3 text-primary mt-1" type="nextButton" />
                </div>
            </div>

            <div class="logo-height-section d-flex"> 
                <label class="font-weight-500">
                    {{ $t('customBranding.logoHeight') }}
                </label>
                <div class="lv-demo_layout">
                    <LvRangeSlider class="slider" v-model="logoHeight" />
                </div>
            </div>

            <div class="logo-link-section">
                <div class="mt-3">
                    <p> {{ $t('customLogo.changeLogoLink') }} </p>
                </div>
                <div class="logo-link-input">
                    <InputTextValidated
                        id="logo-link-text"
                        type="text"
                        :placeholder="$t('customLogo.linkOfLogo')"
                        v-model="logoLink"
                    />
                </div>
                <div v-if="linkAck" class="linkAck mt-2">
                    {{ linkAck }}
                </div>
            </div>
        </div>

        <div class="panel-section-header text-panel-section-header mt-2">
            {{ $t('customBranding.headerSection') }}
        </div>

        <div class="header-section-details d-flex">

            <div class="background-color-section w-50"> 
                <div class="color-section d-flex"> 
                    <label class="font-weight-500"> {{ $t('customBranding.backgroundColor') }} </label>
                    <input type="color" id="backgroundColor" name="backgroundColor" v-model="backgroundColor">
                </div>
                <div class="font-color-section d-flex"> 
                    <label class="font-weight-500"> {{ $t('customBranding.fontColor') }} </label>
                    <!-- <label> #FFFFFF </label> -->
                    <input type="color" id="fontColor" name="fontColor" v-model="fontColor">
                </div> 
            </div> 
            <div class="lv-demo_layout">
                <LvRangeSlider class="slider" v-model="backgroundOpacity" />
            </div>
        </div>

        <div class="panel-section-header text-panel-section-header mt-2">
            {{ $t('customBranding.answerGridStyle') }}
        </div>

        <div class="answer-grid-section-details"> 
            <div class="dark-mode d-flex">
                <div class="dark-mode-radio">
                    <input type="radio" class="radio-button" value="dark" checked="true" name="mode" v-model="mode">
                    <span class="font-weight-500"> {{ $t('customBranding.darkMode') }} </span>
                </div>
                <div class="lv-demo_layout">
                    <LvRangeSlider class="slider" :disabled="mode == 'light'" v-model="darkModeOpacity" />
                </div>
            </div>
            <div class="light-mode d-flex mt-2">
                <div class="ligh-mode-radio">
                    <input type="radio" class="radio-button" value="light" name="mode" v-model="mode">
                    <span class="font-weight-500"> {{ $t('customBranding.lightMode') }} </span>
                </div>
                <div class="lv-demo_layout">
                    <LvRangeSlider class="slider" :disabled="mode == 'dark'" v-model="lightModeOpacity" />
                </div>
            </div>

        </div>

        <!-- {{ selectedTemplate }} -->
    </div>
    <ModalDialog
        ref="dlgPaymentDialog"
        :title="$t('customBranding.saveTemplateAs')"
        :labelOk="$t('customBranding.okLabel')"
        :showCancelIcon="true"
        :displayCancelButton="false"
        @ok="updateChoice('type')"
        @cancel="whenCancel('onlyClose')"
        :displayOkButton="false"
    >
        <div class="form-group display-content">
            <input-text-validated
                :label="$t('customBranding.templateName')"
                type="text"
                id="modalPasswordConfirmation"
                vid="newTemplateName"
                rules=""
                v-model="newTemplateName"
            />

            <span class="template-error" v-if="templateNameErrorMessage">
                {{ templateNameErrorMessage }}
            </span>

            <Btn
                @click.native="saveTemplateName()"
                :label="$t('customBranding.createNew')"
                class="mt-2"
                :disabled="newTemplateName.length == 0"
                :loading="loading"
            />
        </div>
    </ModalDialog>

    <ModalPremiumFeatureDialog
      ref="dlgPremiumFeatureDialog"
      @closeModal="closePremiumDialog"
    />

    <!-- <ModalDialog
      ref="dlgPremiumUser"
      :title="dialogContent.title"
      :labelOk="dialogContent.okLabel"
      :labelCancel="dialogContent.cancelLabel"
      :showCancelIcon="true"
      :displayCancelButton="dialogContent.displayCancelButton"
      @ok="redirectToPage()"
      @cancel="closePremiumDialog()"
      :displayOkButton="dialogContent.displayOkLabel" 
    >
      <div class="text-small w-space" v-html="dialogContent.description"></div>
    </ModalDialog> -->

    <ModalConfirm
      v-show="confirmDeleteDesign"
      :msg="deleteTemplateErrorMessage"
      @confirm="deleteTemplate"
      :loading="loading"
      @cancel="cancelDeleteConfirmation"
      :customClass="'w-space font-16'"
    />

  </SidePanel>

</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import Icon from '../UI/Icon.vue';
import { HTTP } from '@/shared/http';
import { mapGetters, mapState, mapActions } from 'vuex';
import LvRangeSlider from 'lightvue/range-slider';
import CustomBrandingTemplates from './CustomBrandingTemplates.vue';
import ModalPremiumFeatureDialog from '@/components/~Global/Dialogs/ModalPremiumFeatureDialog';

const customTemplate = require('../../shared/customTemplate');
export default {
    name: "CustomBranding",
    props: {
        reRenderData: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            selectedTemplate: null,
            loading: false,
            newTemplateName: '',
            confirmDeleteDesign: false,
            linkAck: null,
            logoHeight: 20,
            backgroundOpacity: 20,
            darkModeOpacity: 60,
            lightModeOpacity: 60,
            mode: '',
            fontColor: '#FFFFFF',
            backgroundColor: '#000000',
            dialogContent: {title: '', description: '', cancelLabel: '', okLabel: '', displayOkLabel: true, displayCancelButton: true},
            templateNameErrorMessage: "",
            logoLink: '',
            deleteTemplateErrorMessage: ''
        }
    },
    components: {
        SidePanel,
        Icon,
        LvRangeSlider,
        CustomBrandingTemplates,
        ModalPremiumFeatureDialog
    },
    created() {
        this.initializeConfig(null);
        // this.tempSave();
    },
    computed: {
        ...mapGetters({
            logoImage: 'logoImage',
            getSelectedTemplate: 'getSelectedTemplate',
            designs: 'designs',
            getPollDesignId: 'getPollDesignId',
            isPremium: 'isPremium'
        }),
        ...mapState({
            poll: (state) => state.poll.poll,
            user: (state) => state.Login.user,
        }),
        header() {
            return this.$t('customBranding.manageDesigns');
        },
        logoThumbnail() {
            return this.updateLogo(this.getSelectedTemplate);
        }
    },
    watch: {
        logoHeight: function(newVal) {
            // document.getElementById("web-logo").style.height = newVal +"px";
            this.updateLogoHeight(newVal);
        },
        mode: function(newVal) {
            let value = (newVal == 'dark');
            this.$store.commit('updateDarkMode', value);
            if(value == true) {
                this.updateDarkModeOpacity(this.darkModeOpacity);
            } else {
                this.updateLighModeOpacity(this.darkModeOpacity);
            }
        },
        darkModeOpacity: function(newVal) {
            this.updateDarkModeOpacity(newVal);
        },
        lightModeOpacity: function(newVal) {
            this.updateLighModeOpacity(newVal);
        },
        backgroundColor: function(newVal) {
            this.updateBackgroundWithOpacity(newVal, this.backgroundOpacity);
        },
        backgroundOpacity: function(newVal) {
            this.updateBackgroundWithOpacity(this.backgroundColor, newVal);
        },
        fontColor: function(newVal) {
            this.updateFontColor(newVal);
        }
    },
    methods: {
        ...mapActions(['loadDesign', 'storeBrandingDesign', 'updateDesignIdInPoll', 'setDarkMode']),
        onCancel() {
            // this.findCurrentPollTemplate();
            this.initializeConfig(null);
            let test = setTimeout(() => {
                this.$emit('cancel');
                clearTimeout(test);
            }, 200);
        },
        openCustomLogo() {
            // this.getSelectedTemplate.config = this.createRequestWithOptions();
            // this.$refs.refBrandingTemplate.updateTemplate(this.getSelectedTemplate);
            let tempTemplateDetails = this.createRequestWithOptions();
            localStorage.setItem("currentTemplate", JSON.stringify(tempTemplateDetails));
            this.$emit('openCustomLogo');
        },
        whenCancel() {
            this.$refs.refBrandingTemplate.stopLoading();
            this.$refs.dlgPaymentDialog.closeModal();
        },
        closePremiumDialog() {
            this.$refs.refBrandingTemplate.stopLoading();
        },
        save(forceSave = false) {

            if(!this.user || (forceSave == false && this.isPremium == false)) {
                this.$refs.dlgPremiumFeatureDialog.openModal(event);
                return;
            }

            this.updateDesignIdInPoll(this.getSelectedTemplate.id);
            let options = forceSave ? this.createRequestWithLimitedOptions() : this.createRequestWithOptions();
            this.loading = true;
            const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
            const url = apiUrl + '/designs/' + this.getSelectedTemplate.id;
            HTTP.put(url, {
                config: options,
                name: this.getSelectedTemplate.name,
                poll_id: this.poll.id
            })
            .then((response) => {
                this.findSelectedTemplateFromList(response.data);
            })
            .catch((err) => {
                alert(this.$t(err.response.data.error));
                this.loading = false;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        saveAs() {
            if(!this.user || !!this.user.plan == false) {
                this.$refs.dlgPremiumFeatureDialog.openModal(event);
                return;
            }
            this.templateNameErrorMessage = "";
            this.$refs.dlgPaymentDialog.openModal();
        },
        deleteTemplateConfirmation() {
            this.deleteTemplateErrorMessage = this.$t('customBranding.deleteTemplate');
            this.loading = true;
            const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
            const url = apiUrl + '/designs/'+ this.poll.id + '/' + this.getSelectedTemplate.id;
            HTTP.delete(url)
            .then((response) => {
                if(parseInt(response.data.count) >= 1) {
                    this.deleteTemplateErrorMessage = this.$t('customBranding.deleteTemplateDescriptive');
                }
            })
            .catch((err) => {
                console.error("error ==> ", err)
                alert(this.$t(err.response.data.error));
            })
            .finally(() => {
                this.confirmDeleteDesign = true;
                this.loading = false;
            })
        },
        cancelDeleteConfirmation() {
            this.loading = false;
            this.confirmDeleteDesign = false;
            this.$refs.refBrandingTemplate.stopLoading();
        },
        deleteTemplate() {
            this.loading = true;
            const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
            const url = apiUrl + '/designs/' + this.getSelectedTemplate.id;
            HTTP.delete(url)
            .then((response) => {
                this.findSelectedTemplateFromList(response.data, 'delete');
            })
            .catch((err) => {
                console.error("error ==> ", err)
                alert(this.$t(err.response.data.error));
            })
            .finally(() => {
                this.loading = false;
                this.confirmDeleteDesign = false;
            });
        },
        saveTemplateName() {

            for(let i = 0; i < this.designs.length; i++) {
                if(this.designs[i].name.toLowerCase() == this.newTemplateName.toLowerCase()) {
                    this.templateNameErrorMessage = this.$t('customBranding.templateNameExists');
                    return;
                }
            }

            let options = this.createRequestWithOptions();
            this.loading = true;
            const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
            const url = apiUrl + '/designs';
            HTTP.post(url, {
                config: options,
                name: this.newTemplateName,
                poll_id: this.poll.id
            })
            .then((response) => {
                this.findSelectedTemplateFromList(response.data, 'saveAs');
            })
            .catch((err) => {
                alert(this.$t(err.response.data.error));
                this.loading = false;
            })
            .finally(() => {
                this.loading = false;
                // this.newTemplateName = '';
                this.$refs.dlgPaymentDialog.closeModal();
            });
        },
        findSelectedTemplateFromList(templateOptions, action = '') {
            let found = false;
            let defaultTemplate = null;
            this.storeBrandingDesign(templateOptions);
            this.$refs.refBrandingTemplate.stopLoading();
            for(let i = 0; i < templateOptions.length; i++) {
                if(action == 'saveAs') {
                    if(templateOptions[i].name == this.newTemplateName) {
                        this.newTemplateName = '';
                        found = true;
                        defaultTemplate = templateOptions[i];
                        break;
                    }
                } else if (action == 'delete') {
                    if(templateOptions[i].isDefault == 1) {
                        found = true;
                        defaultTemplate = templateOptions[i];
                        break;
                    }
                } else {
                    if(templateOptions[i].id == this.poll.design_id) {
                        found = true;
                        defaultTemplate = templateOptions[i];
                        break;
                    }
                }
            }
            if(found == true) {
                this.$refs.refBrandingTemplate.updateTemplate(defaultTemplate);
                this.updateDesignIdInPoll(defaultTemplate.id);
            }
            return defaultTemplate;
        },
        updateLogo(template) {
            let defaultImageName = '/images/logo_neu_weiss_blau_orange.png';
            if(template && template.config.logoDetails.logoImg) {
                defaultImageName = template.config.logoDetails.logoImg;   
            }
            setTimeout(() => {
                document.getElementById("web-logo").src = defaultImageName;
            }, 100);
            console.log("defaultImageName ==> ", defaultImageName);
            this.updateLogoHeight(this.logoHeight);
            return defaultImageName;
        },
        updateBackground(template) {
            if(template && template.config.bg_image_path) {
                let findPollBackground = document.getElementsByClassName('poll-content');
                if(findPollBackground.length > 0) {
                    findPollBackground[0].style.backgroundImage = encodeURI("url("+template.config.bg_image_path+")");
                }
                return template.config.bg_image_path;
            }
            return '';
        },
        createRequestWithOptions() {
            return {
                "reminder" : 2,
                "logoDetails": {
                    "logoImg" : this.getSelectedTemplate.config.logoDetails.logoImg,
                    "height": this.logoHeight,
                    "link": this.getLink(this.logoLink),
                },
                "headerSection": {
                    "backgroundColor": this.backgroundColor,
                    "backgroundOpacity": this.backgroundOpacity,
                    "fontColor": this.fontColor
                },
                "answerGridSection": {
                    "selectedMode": this.mode,
                    "darkModeOpacity": this.darkModeOpacity,
                    "lightModeOpacity": this.lightModeOpacity
                }
            };
        },
        createRequestWithLimitedOptions() {
            let options = {
                "answerGridSection": {
                    "selectedMode": this.mode,
                    "darkModeOpacity": this.darkModeOpacity,
                    "lightModeOpacity": this.lightModeOpacity
                },
                "reminder" : 2,
            };
            for(let i = 0; i < this.designs.length; i++) {
                if(this.designs[i].isDefault == 1) {
                    options.logoDetails = {
                        "logoImg" : this.designs[i].config.logoDetails.logoImg,
                        "height": this.designs[i].config.logoDetails.height,
                        "link": this.getLink(this.designs[i].config.logoDetails.link),
                    };
                    options.headerSection = {
                        "backgroundColor": this.designs[i].config.headerSection.backgroundColor,
                        "backgroundOpacity": this.designs[i].config.headerSection.backgroundOpacity,
                        "fontColor": this.designs[i].config.headerSection.fontColor
                    }
                    break;
                }
            }
            return options;
        },
        renderValue(template) {
            let value = (template.config.answerGridSection.selectedMode == 'dark');
            this.setDarkMode(value).then(() => {
                customTemplate.renderHTML(template);
            });
        },
        initializeConfig(event = null) {
            let currentTemplateValue = this.getSelectedTemplate.config; 
            if(this.reRenderData == false && event == null) {
                let tempCurrentTemplate = localStorage.getItem("currentTemplate");
                if(tempCurrentTemplate) {
                    currentTemplateValue = JSON.parse(tempCurrentTemplate);
                    this.renderValue({config: currentTemplateValue});
                }
            }        
            this.fontColor = currentTemplateValue.headerSection.fontColor;
            this.backgroundColor = currentTemplateValue.headerSection.backgroundColor;
            this.backgroundOpacity = currentTemplateValue.headerSection.backgroundOpacity;

            this.darkModeOpacity = currentTemplateValue.answerGridSection.darkModeOpacity;
            this.lightModeOpacity = currentTemplateValue.answerGridSection.lightModeOpacity;
            this.mode = currentTemplateValue.answerGridSection.selectedMode;

            this.logoLink = this.getLink(currentTemplateValue.logoDetails.link);
            this.logoHeight = currentTemplateValue.logoDetails.height;
            this.logoImg = currentTemplateValue.logoDetails.logoImg;
        },
        // redirectToPage() {
        //     if (this.dialogContent.type != 'register') {
        //         this.$router.push('/membership');
        //     } else {
        //         this.$refs.dlgPremiumUser.closeModal();
        //     }
        // },
        updateDarkModeOpacity(opacity) {
            customTemplate.updateDarkModeOpacity(opacity/100);
        },
        updateLighModeOpacity(opacity) {
            customTemplate.updateLighModeOpacity(opacity/100);
        },
        updateBackgroundWithOpacity(color, opacity = 100) {
            customTemplate.updateBackgroundWithOpacity(color, this.mode, opacity/100);
        },
        updateFontColor(color) {
            customTemplate.updateFontColor(color, this.mode);
        },
        getLink(url) {
            return !/^https?:\/\//i.test(url) ? `http://${url}` : url
        },
        findCurrentPollTemplate() {
            for(let i = 0; i < this.designs.length; i++) {
                if(this.designs[i].id == this.getPollDesignId) {
                    this.$refs.refBrandingTemplate.updateTemplate(this.designs[i]);
                    this.$refs.refBrandingTemplate.renderValue();
                    break;
                }
            }
        },
        updateLogoHeight(height) {
            setTimeout(() => {
                document.getElementById("web-logo").style.height = height +"px";
            }, 200);
        }
    }
}
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

.design-mode {
    color: $dark-grey;
    width: 100%;
    font-size: $small;
    padding: 16px;
    .panel-section-header {
        background-color: rgba(0, 0, 0, 0.8);
        padding: 8px 32px;
        margin-bottom: 8px;
        margin-top: 0px;
        line-height: 20px;
        margin-left: -16px;
        margin-right: -16px;
    }
    .custom-logo-image {
        width: 40px;
        height: 40px;
        background: $dark-grey;
        object-fit: contain;
    }
    .logo-manager-parent {
        justify-content: space-between;
        .logo-image-update {
            display: block;
        }
    }
    .logo-link-section {
        .logo-link-input {
            display: flex;
            span {
                width: 100%;
            }
        } 
        p {
            margin-bottom: unset;
            font-size: $very-small;
        }
    }
    .d-flex {
        justify-content: space-between;
    }
}
.template-error {
    color: $error;
    font-size: $very-small;
}
::v-deep {
    button#dropdownMenuButton {
        width: 100%;
    }
    .dropdown-item {
        padding: unset;
        padding-bottom: 0.25rem;
    }
    .lv-range-slider__fill, .lv-range-slider__knob {
        background-color: $primary !important;
    }
    .lv-range-slider__rail {
        background-color: $primary-hover !important;
        opacity: 0.3;
    }
} 
</style>